import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Select } from 'antd';
import { onChangeShape } from '../../scripts/cy-core';

const ShapeBtn = () => {
  const config = useSelector((state) => state.tree.config);

  const shapeOptions = [];

  shapeOptions.push({ value: 'ellipse', label: 'Tròn' });
  shapeOptions.push({ value: 'rectangle', label: 'Vuông' });
  shapeOptions.push({ value: 'star', label: 'Ngôi sao' });

  const shapeMap = {};
  for (let index = 0; index < shapeOptions.length; index++) {
    const option = shapeOptions[index];
    shapeMap[option.value] = option.label;
  }

  return (
    <Row id="shape-btn">
      <Col span={8} id="shape-des">
        <span>Hình dạng</span>
      </Col>

      <Col id="shape-selection">
        <div style={{ width: '100%' }}>
          <Select
            defaultValue={config.shape}
            showSearch
            style={{ width: 120 }}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            onChange={onChangeShape}
            options={shapeOptions}
          />
          <input type="hidden" id="shape" name="shape" value="1" />
        </div>
      </Col>
    </Row>
  );
};

export default ShapeBtn;
